<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="activeTab == 'notes'">
        <v-list two-line subheader>
          <v-subheader>単語帳一覧</v-subheader>
          <template v-if="notes.length == 0 && isLoading == false">
            <div class="empty-area">
              <v-icon size="150" color="#cccccc"
                >mdi-format-list-bulleted</v-icon
              >
              <p>まだ単語帳が登録されていません。</p>
            </div>
          </template>
          <template v-else>
            <v-list-item
              v-for="note in notes"
              :key="note.data().name"
              @click="goToWordNoteDetail(note)"
            >
              <v-list-item-avatar>
                <v-icon size="38" color="grey lighten-1">mdi-folder</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="note.data().name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="noteDateTitle(note)"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-text="noteWordCountTitle(note)"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>

          <word-note-dialog
            v-model="dialog"
            type="add"
            v-on:saveClicked="saveNewNoteClicked($event)"
            v-on:close="closeDialog"
          ></word-note-dialog>
        </v-list>
        <v-col cols="12">
          <v-btn
            class="word-note-add-button"
            color="primary"
            height="60px"
            dark
            @click="openAddDialog"
          >
            単語帳を追加する
          </v-btn>
        </v-col>
      </v-col>

      <v-col cols="12" v-if="activeTab == 'testMode'">
        <v-list two-line subheader>
          <v-subheader>単語帳一覧</v-subheader>
          <v-list-item
            v-for="note in notes"
            :key="note.data().name"
            @click="goToWordNoteTest(note)"
          >
            <v-list-item-avatar>
              <v-icon size="38" color="grey lighten-1">mdi-book-open</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="note.data().name"></v-list-item-title>
              <v-list-item-subtitle
                v-text="noteDoneTitle(note)"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-text="noteWordCountTitle(note)"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon>
                <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>

      <v-bottom-navigation
        v-model="activeTab"
        @change="tabSelected"
        color="primary"
        grow
        fixed
      >
        <v-btn value="notes" class="disable-dbl-tap-zoom">
          <span>単語帳一覧</span>
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>

        <v-btn value="testMode" class="disable-dbl-tap-zoom">
          <span>暗記モード</span>
          <v-icon>mdi-book-open</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-row>
  </v-container>
</template>

<script>
import { db, fb } from "../plugins/firebase.js";
import { required } from "vuelidate/lib/validators";
import WordNoteDialog from "@/components/WordNoteDialog";
import { jpnDateFormat } from "../plugins/dateUtils.js";

export default {
  name: "UserTop",
  components: {
    WordNoteDialog,
  },
  methods: {
    goToWordNoteDetail(note) {
      this.$store.commit("setCurrentNoteId", note.id);
      this.$router.push({ name: "word-note" });
    },
    goToWordNoteTest(note) {
      this.$store.commit("setCurrentNoteId", note.id);
      this.$router.push({ name: "word-note-test" });
    },
    noteDateTitle(note) {
      const date = note.data().createdAt.toDate();
      return jpnDateFormat(date);
    },
    noteWordCountTitle(note) {
      return `収録数: ${note.data().wordCount}個`;
    },
    noteDoneTitle(note) {
      return `完了数: ${note.data().doneCount}個`;
    },
    openAddDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    saveNewNoteClicked(noteName) {
      this.closeDialog();
      this.saveNewNote(noteName);
    },
    saveNewNote(noteName) {
      const that = this;
      db.collection(`users/${this.uid}/word-notes`)
        .add({
          name: noteName,
          wordCount: 0,
          doneCount: 0,
          createdAt: fb.firestore.FieldValue.serverTimestamp(),
          updatedAt: fb.firestore.FieldValue.serverTimestamp(),
        })
        .then(function (docRef) {
          that.fetchNotes();
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    },
    async fetchNotes() {
      const that = this;
      const snapshot = await db
        .collection(`users/${this.uid}/word-notes`)
        .orderBy("createdAt", "desc")
        .limit(10)
        .get();
      that.isLoading = false;
      this.notes = (snapshot.docs || []).map((doc) => {
        return doc;
      });
    },
    tabSelected(e) {
      this.$store.commit("setSelectedUserTopTab", e);
    },
    updateSelectedTab() {
      this.activeTab = this.$store.getters.selectedUserTopTab;
    },
  },
  data: () => ({
    isLoading: true,
    notes: [],
    dialog: false,
    activeTab: "notes",
  }),
  computed: {
    uid() {
      return this.$store.getters.uid;
    },
  },
  async mounted() {
    this.updateSelectedTab();
    this.fetchNotes();
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin-bottom: 60px;
}
.empty-area {
  text-align: center;
  color: #aaaaaa;
}
.word-note-add-button {
  width: 100%;
}
.disable-dbl-tap-zoom {
  touch-action: manipulation;
}
</style>
